import {useSyncExternalStore} from 'react'
import {LAYOUT_BREAKPOINT} from '@github-ui/pacer/Layout'

function subscribe(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {}
  const mq = window.matchMedia(LAYOUT_BREAKPOINT)
  mq.addEventListener('change', callback)
  return () => mq.removeEventListener('change', callback)
}

function getSnapshot(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(LAYOUT_BREAKPOINT).matches
}

function getServerSnapshot(): boolean {
  return false
}

/**
 * Tracks whether the viewport currently matches the pacer-Layout narrow
 * breakpoint (`max-width: 1024px`) — the same boundary at which the
 * `SidebarToggle` (hamburger menu) becomes visible.
 *
 * Used by `TaskChatHeader` to drive the narrow-only stacking of the
 * action buttons above the title and to collapse the "Give feedback"
 * link button into the kebab menu.
 *
 * Uses `useSyncExternalStore` with a server snapshot of `false` so the
 * initial client render matches SSR output, avoiding hydration mismatches.
 * The hook will re-render with the actual viewport value once mounted.
 */
export function useIsLayoutNarrow(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
